import React, { useEffect, useState } from "react";
import protocolServices from "../../../services/protocolServices";
import fileUpload from "../../../services/fileUpload";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { useRef } from "react";
import { Calendar } from "primereact/calendar";
import moment from "moment";
import { ProgressSpinner } from "primereact/progressspinner";
import HeaderWithBackButton from "../../common/HeaderWIthBackButton";

interface DietData {
  dietsaveid: number;
  dietstartdate: string;
  dietenddate: string;
  totaldays: number;
  question: string;
  answer: string;
  created_at: string;
  isapproved: boolean;
  approveddate: string;
}

const ViewDietChart = (props: any) => {
  const [dietData, setDietData] = useState<DietData[]>([]);
  const [loading, setLoading] = useState(false);
  const [filteredData, setFilteredData] = useState<DietData[]>([]);
  // const [isApproved, setIsApproved] = useState<boolean>(false);
  // const [dietSaveId, setDietSaveId] = useState<number | null>(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedDiet, setSelectedDiet] = useState<DietData | null>(null);
  const [datatableloading, setdatatableloading] = useState(false);
  const [visible, setVisible] = useState(false);
  const toast = useRef<Toast>(null);
  const [editingRowId, setEditingRowId] = useState<number | null>(null);
  const [editingDate, setEditingDate] = useState<Date | null>(null);
  const [prescriptionDate, setPrescriptionDate] = useState<Date | null>(null);
  const [downloadingRecipeId, setDownloadingRecipeId] = useState<number | null>(
    null,
  );

  const onDownloadRecipe = async (rowData: DietData) => {
    const userid = props.userTreatmentid;

    if (!userid) {
      toast.current?.show({
        severity: "warn",
        summary: "Missing User",
        detail: "User ID is missing",
        life: 3000,
      });
      return;
    }

    setDownloadingRecipeId(rowData.dietsaveid);

    try {
      const res: any = await fileUpload.GetRecipeData({
        userid: userid,
      });

      if (res?.status === 200 && res?.data?.length > 0) {
        const matchedRecipe = res.data.find(
          (item: any) => item.dietsaveid === rowData.dietsaveid,
        );

        if (matchedRecipe?.presigned_url) {
          window.open(matchedRecipe.presigned_url, "_blank");
        } else {
          toast.current?.show({
            severity: "warn",
            summary: "No Recipe",
            detail: "Recipe PDF not available for this diet",
            life: 3000,
          });
        }
      }
    } catch (error) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to download recipe",
        life: 3000,
      });
    } finally {
      setDownloadingRecipeId(null);
    }
  };

  /* ----------------------------------------
     Parse markdown table from answer
  -----------------------------------------*/
  const parseMarkdownTable = (markdown: string) => {
    if (!markdown) return [];

    const lines = markdown
      .split("\n")
      .filter((line) => line.trim().startsWith("|") && !line.includes("-----"));

    if (lines.length < 2) return [];

    const headers = lines[0]
      .split("|")
      .slice(1, -1)
      .map((h) => h.trim());

    const rows = lines.slice(1);

    const parsedRows = rows.map((row) => {
      const values = row
        .split("|")
        .slice(1, -1)
        .map((v) => v.trim());

      const rowObj: any = {};
      headers.forEach((header, index) => {
        rowObj[header] = values[index] ?? "";
      });

      return rowObj;
    });
    let lastDay = "";
    parsedRows.forEach((row) => {
      if (row["Day"]) {
        lastDay = row["Day"];
      } else {
        row["_hideDay"] = true;
        row["Day"] = lastDay;
      }
    });

    return parsedRows;
  };

  // const buildMarkdownFromTable = (rows: any[]) => {
  //   if (!rows || rows.length === 0) return "";

  //   const headers = Object.keys(rows[0]);

  //   let markdown = `| ${headers.join(" | ")} |\n`;
  //   markdown += `| ${headers.map(() => "-----").join(" | ")} |\n`;

  //   rows.forEach((row) => {
  //     markdown += "| " + headers.map((h) => row[h] || "").join(" | ") + " |\n";
  //   });

  //   return markdown;
  // };

  // const onCellEditComplete = (e: any) => {
  //   const { rowIndex, field, newValue } = e;

  //   setDietData((prev) => {
  //     const updated = [...prev];
  //     updated[rowIndex] = {
  //       ...updated[rowIndex],
  //       [field]: newValue,
  //     };
  //     return updated;
  //   });
  // };

  // const onCellEditInit = () => {
  //   setIsEditing(true);
  // };

  // const onCellEditDone = (e: any) => {
  //   onCellEditComplete(e);
  //   setIsEditing(false);
  // };

  /* ----------------------------------------
     API call
  -----------------------------------------*/
  const GetDietData = () => {
    setLoading(true);

    const data = {
      userid: props.userTreatmentid,
    };

    protocolServices.GetDietData(data).then((res: any) => {
      //     if (res.data && res.data.length > 0) {
      //       const markdownAnswer = res.data[0].answer;
      //       const parsedTable = parseMarkdownTable(markdownAnswer);
      //       setDietData(parsedTable);
      //       setIsApproved(res.data[0].isapproved);
      //       setDietSaveId(res.data[0].dietsaveid);

      //       setPrescriptionDate(
      //         res.data[0].prescriptiondate
      //           ? new Date(res.data[0].prescriptiondate)
      //           : null
      //       );
      //     } else {
      //       setDietData([]);
      //     }
      //     setLoading(false);
      //   });
      // };
      try {
        if (res.status === 200) {
          setDietData(res.data);
          setFilteredData(res.data);
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    });
  };

  // const handleApproveDiet = async () => {
  //   // if (isPrescriptionPassed) {
  //   //   toast.current?.show({
  //   //     severity: "warn",
  //   //     summary: "Cannot Approve",
  //   //     detail: "Prescription date is passed, cannot approve the diet",
  //   //     life: 3000,
  //   //   });
  //   //   return;
  //   // }

  //   const prescriptionId = props.prescriptionid || props.editPrescriptionid;

  //   if (!prescriptionId) return;

  //   const payload = {
  //     prescriptionid: prescriptionId,
  //     IsApproved: true,
  //   };

  //   try {
  //     setLoading(true);

  //     const res: any = await protocolServices.UpdateDietApproval(payload);

  //     if (res.status === 200 && res.data?.p_response) {
  //       setIsApproved(true); //  lock UI immediately

  //       // Optional: reload diet data for safety
  //       GetDietData();
  //     } else {
  //       console.error("Approval failed:", res.data?.p_msg);
  //     }
  //   } catch (error) {
  //     console.error("Approval error:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  useEffect(() => {
    if (props.userTreatmentid) {
      GetDietData();
    }
  }, [props.userTreatmentid]);

  useEffect(() => {
    if (searchQuery) {
      const lower = searchQuery.toLowerCase();

      const filtered = dietData.filter((item: any) =>
        Object.keys(item).some((key) =>
          String(item[key]).toLowerCase().includes(lower),
        ),
      );

      setFilteredData(filtered);
    } else {
      setFilteredData(dietData);
    }
  }, [searchQuery, dietData]);

  const handleSearch = (event: any) => {
    setSearchQuery(event.target.value);
  };

  // const handleSaveDiet = async () => {
  //   if (!dietSaveId || isApproved) return;

  //   const updatedMarkdown = buildMarkdownFromTable(dietData);

  //   const payload = {
  //     dietsaveid: dietSaveId,
  //     answer: updatedMarkdown,
  //   };

  //   try {
  //     setLoading(true);

  //     const res: any = await protocolServices.UpdateDietAnswer(payload);

  //     if (res.status === 200 && res.data?.p_response) {
  //       GetDietData(); // refresh from DB
  //     } else {
  //       console.error("Save failed:", res.data?.p_msg);
  //     }
  //   } catch (error) {
  //     console.error("Save error:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const SrNo = (rowData: any, index: any) => {
    return <span>{index.rowIndex + 1}</span>;
  };

  const formatDate = (value: string) => {
    if (!value) return "-";

    const date = new Date(value);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  };

  const isDietExpired = (dietEndDate: string) => {
    if (!dietEndDate) return false;

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const endDate = new Date(dietEndDate);
    endDate.setHours(0, 0, 0, 0);

    return endDate < today;
  };

  // const today = new Date();
  // today.setHours(0, 0, 0, 0);

  // const isPrescriptionPassed = !!(
  //   prescriptionDate &&
  //   new Date(prescriptionDate).setHours(0, 0, 0, 0) < today.getTime()
  // );

  // const isApproveDisabled =
  //   isApproved ||
  //   dietData.length === 0 ||
  //   loading ||
  //   isEditing ||
  //   isPrescriptionPassed;

  // const headers: string[] = dietData.length > 0 ? Object.keys(dietData[0]) : [];

  /* ----------------------------------------
     Actions
  -----------------------------------------*/
  const onViewClick = (rowData: DietData) => {
    setdatatableloading(true);
    setVisible(true);

    setTimeout(() => {
      setSelectedDiet(rowData);
      setdatatableloading(false);
    }, 500);
  };

  const onEditClick = (rowData: DietData) => {
    setEditingRowId(rowData.dietsaveid);
    setEditingDate(new Date(rowData.dietstartdate));
  };

  const onSaveStartDate = async (rowData: DietData) => {
    if (!editingDate) {
      toast.current?.show({
        severity: "warn",
        summary: "Missing Date",
        detail: "Please select start date",
        life: 3000,
      });
      return;
    }

    const data = {
      dietsaveid: rowData.dietsaveid,
      dietstartdate: moment(editingDate).format("YYYY-MM-DD"),
    };

    try {
      const res: any = await protocolServices.UpdateDietStartDate(data);

      if (res?.status === 200 && res.data?.p_response) {
        toast.current?.show({
          severity: "success",
          summary: "Updated",
          detail: res.data?.p_msg || "Start date updated successfully",
          life: 3000,
        });

        setEditingRowId(null);
        setEditingDate(null);

        GetDietData(); // refresh updated end date too
      } else {
        toast.current?.show({
          severity: "warn",
          summary: "Warning",
          detail: res.data?.p_msg || "Update failed",
          life: 3000,
        });
      }
    } catch (error) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to update start date",
        life: 3000,
      });
    }
  };

  const Action = (rowData: any) => {
    return (
      <React.Fragment>
        <Button
          className="table-button"
          tooltip="View Diet"
          onClick={() => onViewClick(rowData)}
        >
          <i className="pi pi-eye" style={{ color: "#e0a553" }}></i>
        </Button>

        {/* Download PDF button */}
        <Button
          className="table-button"
          tooltip="Download Recipe"
          onClick={() => onDownloadRecipe(rowData)}
        >
          <i className="pi pi-download" style={{ color: "#e0a553" }}></i>
        </Button>
      </React.Fragment>
    );
  };

  const headers: string[] =
    selectedDiet && selectedDiet.answer
      ? Object.keys(parseMarkdownTable(selectedDiet.answer)[0] || {})
      : [];

  /* ----------------------------------------
     UI (Editable Grid)
  -----------------------------------------*/
  return (
    <div>
      <Toast ref={toast} />
      <HeaderWithBackButton
        controls={[]}
        handleSearch={handleSearch}
        searchQuery={searchQuery}
      />
      <div className="table-section mt-3">
        <DataTable
          value={filteredData}
          dataKey="dietsaveid"
          tableStyle={{ minWidth: "60rem" }}
          // scrollHeight="600px"
          scrollHeight="calc(100vh - 340px)"
          paginator
          rows={15}
          loading={loading}
          emptyMessage="No history found."
          // expandedRows={expandedRows}
          // onRowToggle={(e) => setExpandedRows(e.data)}
          // rowExpansionTemplate={rowExpansionTemplate}
          className="treatment-history"
        >
          <Column
            field="srNo"
            header="Sr. No."
            style={{ minWidth: "3rem" }}
            body={SrNo}
          />
          {/* <Column
            field="dietstartdate"
            header="Start Date"
            body={(rowData) => formatDate(rowData.dietstartdate)}
            sortable
          /> */}
          <Column
            field="dietstartdate"
            header="Start Date"
            sortable
            body={(rowData: DietData) => {
              const isEditing = editingRowId === rowData.dietsaveid;
              const expired = isDietExpired(rowData.dietenddate);

              return (
                <div className="flex align-items-center gap-2">
                  {isEditing ? (
                    <>
                      <Calendar
                        value={editingDate}
                        onChange={(e) => setEditingDate(e.value as Date)}
                        dateFormat="dd/mm/yy"
                        minDate={new Date()}
                        showIcon
                        // className="w-full"
                      />
                      <i
                        className="pi pi-check"
                        style={{
                          color: "#e0a553",
                          cursor: "pointer",
                          fontSize: "1.2rem",
                        }}
                        onClick={() => onSaveStartDate(rowData)}
                      />
                    </>
                  ) : (
                    <>
                      <span>{formatDate(rowData.dietstartdate)}</span>
                      <i
                        className="pi pi-pencil"
                        style={{
                          color: expired ? "#bdbdbd" : "#e0a553",
                          cursor: expired ? "not-allowed" : "pointer",
                          fontSize: "1rem",
                          opacity: expired ? 0.6 : 1,
                        }}
                        onClick={() => {
                          if (!expired) onEditClick(rowData);
                        }}
                      />
                    </>
                  )}
                </div>
              );
            }}
          />
          <Column
            field="dietenddate"
            header="End Date"
            body={(rowData) => formatDate(rowData.dietenddate)}
            sortable
          />
          <Column
            field="totaldays"
            header="Total Days"
            sortable
            body={(rowData: DietData) => rowData.totaldays || "-"}
          />
          <Column
            field="Action"
            header="Action"
            style={{ minWidth: "100px" }}
            body={Action}
          ></Column>
        </DataTable>
      </div>

      <div className="card flex justify-content-center">
        <Dialog
          header="Diet Chart Details"
          visible={visible}
          onHide={() => setVisible(false)}
          className="pop-up-close-treatement"
          draggable={false}
        >
          {datatableloading ? (
            <div
              className="text-center mt-5 flex justify-content-center"
              style={{
                width: "65vw",
                height: "16vw",
                flexDirection: "column",
              }}
            >
              <ProgressSpinner
                strokeWidth="1"
                fill="var(--surface-ground)"
                animationDuration=".8s"
              />
            </div>
          ) : (
            <div className="p-3">
              <h5 className="med-text">Diet Chart</h5>
              <div className="table-section mt-3" style={{ overflowX: "auto" }}>
                <DataTable
                  // value={selectedDiet ? [selectedDiet] : []}
                  value={
                    selectedDiet?.answer
                      ? parseMarkdownTable(selectedDiet.answer)
                      : []
                  }
                  emptyMessage="No diet data found"
                  scrollable
                  scrollHeight="400px"
                  tableStyle={{ minWidth: "60rem" }}
                  className="p-datatable-sm diet-chart-table"
                >
                  {headers.map((header) => (
                    <Column
                      key={header}
                      field={header}
                      header={header}
                      // body={(rowData) => rowData[header]}
                      body={(rowData) => {
                        if (header === "Day" && rowData._hideDay) return "";
                        return rowData[header];
                      }}
                      style={{ minWidth: "250px" }}
                    />
                  ))}
                </DataTable>
              </div>
            </div>
          )}
        </Dialog>
      </div>
    </div>
  );
};

export default ViewDietChart;
